module.exports = __webpack_public_path__ + "img/avatar.0471ee0c.png";